<table>

  <tbody *ngIf="ranges && ranges.length > 0">
    <tr *ngFor="let range of ranges" [ngClass]="{ 'selected': range === selectedRange }" (click)="onSelect(range)">
      <td name="Rappot">
        {{ range.label }}
      </td>
      <td style="width: 64px;" class="actions">
        <a class="action-btn" *ngIf="range === selectedRange">
          <t-icon name="check"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!ranges || ranges.length === 0">
    <tr>
      <td class="text-center">
        Ce rapport nécessite au moins un exercice comptable
      </td>
    </tr>
  </tbody>

</table>